import { render } from "./ContentContainer.vue?vue&type=template&id=74b7a28e&scoped=true"
import script from "./ContentContainer.vue?vue&type=script&lang=js"
export * from "./ContentContainer.vue?vue&type=script&lang=js"

import "./ContentContainer.vue?vue&type=style&index=0&id=74b7a28e&lang=scss&scoped=true"

import exportComponent from "/Users/rantalmor/Desktop/volta-vue/proposal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74b7a28e"]])

export default __exports__